export default __webpack_public_path__ + "static/home_page_sdg-fdc871f5b1e8c161e732e5c529283ac2.png";